import {Component} from "@angular/core";
import {FUIAbstractLoader} from "../abstract-loader";

@Component({
    selector: "fui-ellipsis-loader",
    styleUrls: ["./ellipsis-loader.component.scss"],
    templateUrl: "./ellipsis-loader.component.html"
})
export class FUIEllipsisLoaderComponent extends FUIAbstractLoader {
}
